import { usePunditUserContext } from "@circle-react/contexts/punditUserContext";

import { useCurrentPlanApi } from "@/react/components/SettingsApp/Plan/hooks/useCurrentPlanApi";
import { isCommunityAdmin } from "@/react/helpers/communityMemberHelpers";
import { isPlanProfessional } from "@/react/helpers/planHelpers";
import { usePlanStatus } from "@/react/hooks/usePlanStatus";

export const useShouldShowPlanTrial = () => {
  const { currentPlan } = useCurrentPlanApi();
  const {
    isCommunityOnTrial,
    isCommunityOnPaidPlan,
    isCommunitySubscriptionOnGracePeriod,
  } = usePlanStatus();
  const { currentCommunityMember, currentCommunity } = usePunditUserContext();

  const isPlanTrialActive = currentPlan?.plan_trial?.active || false;
  const isPlanTrialOptedOut = currentPlan?.plan_trial?.opted_out || false;
  const isPlanTrialConverted = currentPlan?.plan_trial?.converted || false;
  const isAdmin = isCommunityAdmin(currentCommunityMember);
  const isSubscriptionActive =
    currentCommunity?.subscription?.status === "active";

  return (
    isAdmin &&
    !isCommunityOnTrial &&
    !isPlanTrialActive &&
    !isPlanTrialOptedOut &&
    !isPlanTrialConverted &&
    !isCommunitySubscriptionOnGracePeriod &&
    isCommunityOnPaidPlan &&
    isSubscriptionActive &&
    currentPlan &&
    isPlanProfessional(currentPlan.tier)
  );
};
